export enum PackageStatus {
  USED = "USED",
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
}
